import Greenbay1 from '../../Media/Greenbay/Kamar 2 (1).webp'
import Greenbay2 from '../../Media/Greenbay/Kamar 2 (2).webp'
import Greenbay3 from '../../Media/Greenbay/Kamar 2 (3).webp'
import Greenbay4 from '../../Media/Greenbay/Kamar 2 (4).webp'
import Greenbay5 from '../../Media/Greenbay/Kamar 2 (5).webp'




const Kamar2images =[
    Greenbay1,Greenbay2,Greenbay3,Greenbay4,Greenbay5
]

export default Kamar2images;